import React, { useMemo,useRef} from "react";
import {Col, Dropdown, Form, Row} from "react-bootstrap";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import { FormLabelStyle } from "./FormLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { Select, MenuItem } from "@material-ui/core";
import OverflowTool from "../tooltip/OverflowTool";
import Reveal from "../request/Reveal";
import SourceReveal from "../request/SourceReveal";
import RequestUtils from "../../utils/RequestUtils";
import EmailPopper from "../popper/EmailPopper";
import AudioLayout from "../request/AudioLayout";
import {parseAudioLayout} from "../processing/ProcessForm";
import moment from "moment";
import "../../styles/form.scss";
import {DropDownToggle} from "../../styles/BootstrapStyles";
import Moment from "moment-timezone";
import {ReactComponent as CalendarIcon} from "../../assets/icons/calendar.svg";
import ConfigUtils from "../../utils/ConfigUtils";
import { PERMITTED_ROLES } from "../../constants/UserRoles";

export const renderFormFields = (
    fieldsArray,
    handleOption,
    data,
    setData,
) => {   
    return _.map(fieldsArray, (field) => {
        if (_.isEmpty(field)) {
            return null;
        }
        switch (field.type) {
            case "textarea":
                return (textAreaForm(field, data, handleOption));
            case "boolean":
                return (checkboxForm(field, data, handleOption));
            case "list":
                return _.get(field, "isEditable") ? (
                    editableListForm(field, data, handleOption)
                ) : (
                    <>
                        {nonEditableListForm(field, data, handleOption)}
                        <SourceReveal
                            key={"source_reveal-" + field.ref}
                            showing={_.get(data, _.get(field, "ref"))}
                            parentItem={field}
                            items={_.get(field, "reveal")}
                            data={data}
                            handleOption={handleOption}
                            setData={setData}
                        />
                    </>
                );
            case "date":
                return (
                    <DateForm
                        field={field}
                        data={data}
                        handleOption={handleOption}
                    />
                );
            case "email":
                return (emailForm(field, data, setData));
            case "radio":
                return (radioForm(field, data, "", "", handleOption));
            default:
                return _.get(field, "multiLine", false) ? (
                    multiLineForm(field, data, handleOption)
                ) : (
                        <>
                            {textForm(field, data, handleOption)}
                            <SourceReveal
                                key={"source_reveal-" + field.ref}
                                showing={_.get(data, _.get(field, "ref"))}
                                parentItem={field}
                                items={_.get(field, "reveal")}
                                data={data}
                                handleOption={handleOption}
                                setData={setData}
                                />
                        </>
                );
        }
    });
};

export const renderAlternateFormFields = (
    fieldsArray,
    isEditing,
    handleOption,
    data,
    error,
    dueDate,
    handleMultiple
) => {
    return _.map(fieldsArray, (field) => {
        if (_.isEmpty(field)) {
            return null;
        }
        switch (field.type) {
            case "textarea":
                return (textAreaForm(field, data, handleOption));
            case "time":
                return (timeForm(field, data, handleOption));
            case "boolean":
                return (
                    <>
                        {checkboxForm(field, data, handleOption)}
                        {_.has(data, "screenerType", false) ? (
                            <Reveal
                                key={"source_reveal-" + field.ref}
                                showing={_.get(data, _.get(field, "ref"))}
                                parentItem={field}
                                items={_.get(field, "reveal")}
                                data={data}
                                isEditing={isEditing}
                                handleOption={handleOption}
                                error={error}
                                dueDate={dueDate}
                                handleMultiple={handleMultiple}
                            />
                        ) : null}
                    </>
                )
            case "radio":
                return (radioForm(field, data, dueDate, error, handleOption));
            case "number":
                return (numberForm(field, data, handleOption));
            case "date":
                return (
                    <DateForm
                        field={field}
                        data={data}
                        dueDate={dueDate}
                        handleOption={handleOption}
                    />
                );
            case "helptext":
                return (helpTextForm(field, dueDate));
            case "listWithOther":
                return (
                    <>
                        {nonEditableListForm(field, data, handleOption, error, dueDate, handleMultiple)}
                        {_.toLower(_.get(data, _.get(field, "ref"))) === "other" ? (
                            <Form.Group key={"group-Other_codec"} controlId={"other_f"}>
                                <Form.Label className="formLabel">
                                    <OverflowTool text={<FormLabelStyle label={"Other Codec"} impField={false} />} />
                                </Form.Label>
                                <Form.Control
                                    className="formInput"
                                    disabled={!isEditing}
                                    placeholder={"Other Codec"}
                                    required={false}
                                    value={_.get(data, "codecOther", "")}
                                    autoComplete="off"
                                    onChange={(e) => {
                                        e.preventDefault();

                                        handleOption("codecOther", e.target.value);
                                    }}/>
                            </Form.Group>
                        ) : null}
                    </>
                );
            case "list":
                let revealOption = _.size(_.get(field, "reveal", [])) > 0;
                let revealArray = [];
                if (revealOption) {
                    revealArray = _.get(field, "reveal", []);
                }

                const onChangeHandler = (ref, value, sourceKey) => {
                    if (ref === field.ref && revealOption) {
                        let oldValue = _.get(data, _.get(field, "ref", ""));
                        let findData = _.find(revealArray, (array) => {
                            return _.get(array, "refData") === oldValue;
                        });
                        let cloneData = { ...data };
                        _.map(_.get(findData, "components"), (val) => {
                            if (!_.includes(["address", "name"], val)) {
                                cloneData = _.omit(cloneData, val);
                            }
                        });
                        handleMultiple(ref, value, cloneData);
                    } else if (sourceKey) {
                        handleOption(ref, value, sourceKey);
                    } else {
                        handleOption(ref, value);
                    }
                }

                return (
                    nonEditableListForm(field, data, onChangeHandler, error, dueDate, handleMultiple, null)
                )
            case "email":
                return (
                    <EmailField
                        key={"email-field" + field.ref}
                        field={field}
                        data={data}
                        isEditing={isEditing}
                        handleOption={handleOption}/>
                );
            default:
                return (repeatedForm(field, data, isEditing, handleOption))
        }
    });
};

export const renderContentProtectionFields = (
    fieldsArray,
    isEditing,
    handleOption,
    data,
    sourceKey
) => {
    return _.map(fieldsArray, (field) => {
        if (_.isEmpty(field)) {
            return null;
        }
        switch (field.type) {
            case "textarea":
                return (textAreaForm(field, data, handleOption, sourceKey));
            case "time":
                return (timeForm(field, data, handleOption, sourceKey));
            case "boolean":
                return (checkboxForm(field, data, handleOption, sourceKey));
            case "list":
                return (
                    nonEditableListForm(field, data, handleOption, null, null, null, sourceKey)
                );
            default:
                return (repeatedForm(field, data, isEditing, handleOption, sourceKey))
        }
    });
};

const EmailField = ({ field, data, isEditing, handleOption }) => {
    const { label, required, ref, placeholder } = field;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const numsOfEmail = useMemo(() => _.get(data, ref, ['']).length, [data]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const currentData = useMemo(() => _.get(data, ref, ['']), [data]);
    return (
        <Form.Group key={"group-" + ref} controlId={ref}>
            <Form.Label className="formLabel">
                <OverflowTool text={<FormLabelStyle label={label} impField={required} />} />
            </Form.Label>
            {currentData.map((value, idx) => (
                <div key={idx} style={{ display: 'flex', alignItems: 'center', marginTop: idx > 0 ? '15px' : 'initial' }}>
                    <Form.Control
                        className="formInput"
                        disabled={!isEditing}
                        placeholder={placeholder || label}
                        required={required}
                        value={value}
                        autoComplete="off"
                        onChange={(e) => {
                            e.preventDefault();
                            const fieldVal = e.target.value;
                            data[ref] = data[ref] || [];
                            data[ref][idx] = fieldVal;
                            handleOption(ref, _.get(data, ref));
                        }}>
                    </Form.Control>
                    <div style={{ width: '32px', marginLeft: numsOfEmail > 1 && idx === numsOfEmail - 1 ? '12px' : '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {numsOfEmail > 1 && (<div role="button" style={{ fontSize: '32px', color: '#D49F26' }} onClick={() => {
                            const emails = currentData;
                            emails.splice(idx, 1);
                            handleOption(ref, emails);
                        }}>-</div>)}
                        {idx === numsOfEmail - 1 && (<div role="button" style={{ fontSize: '32px', color: '#D49F26', marginLeft: numsOfEmail > 1 && idx === numsOfEmail - 1 ? '5px' : 0 }} onClick={() => {
                            const emails = currentData;
                            emails.push('');
                            handleOption(ref, emails);
                        }}>+</div>)}
                    </div>
                </div>))}
        </Form.Group>
    );
}

export const renderScreenerTypeFields = (process, screenerTypes, onChange) => {
    return (
        <Form.Group
            key={"group-screeners-type"}
            controlId={"screeners-type"}
            className="m-0 p-0">
            <Form.Label
                className="formLabel">
                {<FormLabelStyle label={"Select a Screener Type"} impField={true} />}
            </Form.Label>
            <Form.Control
                as={Select}
                className="formInputSelect"
                classes={{
                    root: "dropdownRoot"
                }}
                disableUnderline={true}
                displayEmpty
                value={_.get(process, "screenerType") || ""}
                onChange={onChange}
                required={true}
                inputProps={{
                    id: "screenerType"
                }}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    getContentAnchorEl: null,
                    style: {
                        zIndex: 15000
                    }
                }}>
                <MenuItem className="dropdownSelect" key={-1} value={""}>
                    -----
                </MenuItem>
                {_.map(screenerTypes, (item, index) => {
                    return (
                        <MenuItem className="dropdownSelect"  key={index} value={_.get(item, "ref")}>
                            {_.get(item, "label")}
                        </MenuItem>
                    );
                })}
            </Form.Control>
        </Form.Group>
    );
};

export const renderProcessGroupFields = (sourceLocation, process, metadataFields, fileFields, onProcessGroupChange, onFileTypeChange, onFileSelect) => {
    const intendedFile = ConfigUtils.getIntendedUseFile();
    return (
        <>
            <Row className="m-0 p-0">
                <label className="formLabel">
                    {<FormLabelStyle label={"Select a File Type"} impField={true} />}
                </label>
                <Form.Group key={"process-group"}
                            style={{ margin: "0", padding: "0 10px 0 0" }}
                            as={Col}
                            xs={6}
                            controlId={"process-group-type"}>
                    <Form.Control
                        as={Select}
                        className="formInputSelect"
                        classes={{
                            root: "dropdownRoot"
                        }}
                        disableUnderline={true}
                        value={_.get(process, "fileType", "") || ''}
                        onChange={onProcessGroupChange}
                        required={true}
                        displayEmpty
                        inputProps={{
                            id: "fileType"
                        }}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                            getContentAnchorEl: null,
                            style: {
                                zIndex: 15000
                            }
                        }}>
                        <MenuItem className="dropdownSelect" value="">
                            -----
                        </MenuItem>
                        {_.map(metadataFields, (item, index) => {
                            return (
                                <MenuItem className="dropdownSelect"
                                          key={"process-type-list" + index}
                                          value={_.get(item[0], "group")}>
                                    {_.get(item[0], "group")}
                                </MenuItem>
                            );
                        })}
                    </Form.Control>
                </Form.Group>
                <Form.Group key={"file-type"}
                            className="m-0 px-0 pr-0 pl-2"
                            as={Col}
                            xs={6}
                            controlId={"fileCreation-type"}>
                    <Form.Control
                        as={Select}
                        value={_.get(process && process.profile, "description", "")}
                        className="formInputSelect"
                        classes={{
                            root: "dropdownRoot"
                        }}
                        onChange={onFileTypeChange}
                        required={true}
                        disableUnderline={true}
                        displayEmpty
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                            getContentAnchorEl: null,
                            style: {
                                zIndex: 15000
                            }
                        }}>
                        <MenuItem className="dropdownSelect"value={""}>
                            -----
                        </MenuItem>
                        {_.map(fileFields, (item, index) => {
                            return (
                                <MenuItem className="dropdownSelect"
                                          key={index}
                                          value={_.get(item, "ref")}>
                                    {_.get(item, "label")}
                                </MenuItem>
                            );
                        })}
                    </Form.Control>
                </Form.Group>
            </Row>
            <Dropdown
                onSelect={onFileSelect}
                className="dropdown">
                <DropDownToggle as={"span"} id="dropdown-custom-components">
                    Need help deciding?
                </DropDownToggle>
                <Dropdown.Menu
                    id={"Menu_Notify"}
                    className="notificationMenu formList">
                    {_.map(RequestUtils.getIntendedFilter(intendedFile, _.get(sourceLocation, "type")), (item, index) => {
                        return (
                            <Dropdown.Item
                                key={"file-dropdown" + index}
                                className="dropdownItem"
                                eventKey={_.get(item, "fileType")}>
                                {_.get(item, "label")}
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
};

export const renderAdvancedOptions = (process, additionalFileFields, handleOption, updateAudioLayout) => {
    const frameRates = ConfigUtils.getFrameRates();
    return (
        <>
            {_.get(process, "advancedOptions", false) ? (
                <Form.Group controlId="frame_rate" className="m-0 p-0">
                    <Form.Label className="formLabel">Convert Frame Rate</Form.Label>
                    <Form.Control
                        as={Select}
                        className="formInputSelect"
                        classes={{
                            root: "dropdownRoot"
                        }}
                        disableUnderline={true}
                        displayEmpty
                        value={_.get(process, "frameRate", null) || ''}
                        onChange={handleOption}
                        inputProps={{
                            id: "frameRate"
                        }}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                            getContentAnchorEl: null,
                            style: {
                                zIndex: 15000
                            }
                        }}>
                        <MenuItem className="dropdownSelect" value="">
                            -----
                        </MenuItem>
                        {_.map(frameRates, (item, index) => {
                            return (
                                <MenuItem className="dropdownSelect"
                                          key={index}
                                          value={item}>
                                    {item}
                                </MenuItem>
                            );
                        })}
                    </Form.Control>
                </Form.Group>
            ) : null}
            {_.get(process, "advancedOptions", false) && <AudioLayout
                audioLayout={parseAudioLayout(_.get(process, "audioLayout", null))}
                defaultValues={_.get(additionalFileFields, "defaultAudioLayout", null)}
                audioMsg={_.get(additionalFileFields, "defaultAudioMessage", null)}
                advanceOptions={_.get(process, "advancedOptions", false)}
                placeholderText={!_.isEmpty(_.get(additionalFileFields, "defaultAudioLayout")) ? "Default Audio Layout" : null}
                update={updateAudioLayout}
            />}
        </>
    );
};

export const renderSubtitlesLanguages = (process, handleOption) => {
    return (
        <>
            {_.get(process, "captions") ? (
                <Form.Group controlId="captionLanguages" className="m-0 p-0">
                    <Form.Label className="formLabel">Enter Languages</Form.Label>
                    <Form.Control
                        name="captionLanguages"
                        className="formInput"
                        placeholder={"Enter Languages"}
                        value={_.get(process, "captionLanguages", "")}
                        autoComplete="off"
                        onChange={handleOption} 
                    />
                </Form.Group>
            ) : null}
        </>
    );
};

export const renderAudioSideCarLanguages = (process, handleOption) => {
    return (
        <>
            {_.get(process, "audioSidecar") ? (
                <Form.Group controlId="audioLanguages" className="m-0 p-0">
                    <Form.Label className="formLabel">Enter Languages</Form.Label>
                    <Form.Control
                        name="audioLanguages"
                        className="formInput"
                        placeholder={"Enter Languages"}
                        value={_.get(process, "audioLanguages", "")}
                        autoComplete="off"
                        onChange={handleOption} 
                    />
                </Form.Group>
            ) : null}
        </>
    );
};

export const renderQCCheckListFormFields = (
    fieldsArray,
    isEditing,
    handleOption,
    data,
    error,
) => {
    return _.map(fieldsArray, ({...field}) => {
        if (_.isEmpty(field)) {
            return null;
        }
        // If editing is not allowed then disable all fields.
        if (!isEditing) {
            field.readOnly = true;
        }
        switch (field.type) {
            case "helptext":
                return (helpTextQC(field));
            case "textarea":
                return (textAreaForm(field, data, handleOption));
            default:
                return (radioQC(field, data, error, handleOption));
        }
    });
}

const textAreaForm = (field, data, handleOption, sourceKey = null) => {
    return (
        <Form.Group
            className="m-0 p-0"
            key={"group-" + field.ref}
            as={Row}
            controlId={field.ref}>
            {formLabel(field)}
            <Form.Control
                as="textarea"
                rows={2}
                autoComplete="off"
                readOnly={field.readOnly}
                className="formInput"
                value={_.get(data, _.get(field, "ref", ""))}
                placeholder={field.placeholder || field.label}
                onChange={(e) => {
                    e.preventDefault();
                    let key = field.ref;
                    let value = e.target.value;
                    if (sourceKey) {
                        handleOption(key, value, sourceKey)
                    } else {
                        handleOption(key, value);
                    }
                }}
                required={field.required}
            />
        </Form.Group>
    );
}

const timeForm = (field, data, handleOption, sourceKey = null) => {
    return (
        <Form.Group key={"group-" + field.ref} controlId={field.ref}>
            {formLabel(field)}
            <Form.Control
                type="time"
                className="timePicker formInput"
                name={field.label}
                required={field.required}
                onChange={(e) => {
                    e.preventDefault();
                    let key = field.ref;
                    let value = e.target.value;
                    if (sourceKey) {
                        handleOption(key, value, sourceKey)
                    } else {
                        handleOption(key, value);
                    }
                }}
                value={_.get(data, _.get(field, "ref"), "00:00")}
            />
        </Form.Group>
    );
}

const checkboxForm = (field, data, handleOption, sourceKey = null) => {
    return (
        <Form.Group
            className="m-0 p-0"
            key={"group-" + field.ref}
            controlId={field.ref}
            as={Row}>
            <OverflowTool
                text={
                    <Form.Check
                        type="checkbox"
                        className="formCheckbox"
                        defaultChecked={_.get(data, field.ref, "")}
                        required={field.required}
                        onChange={(e) => {
                            let key = field.ref;
                            let value = e.target.checked;
                            if (sourceKey) {
                                handleOption(key, value, sourceKey);
                            } else {
                                handleOption(key, value, field.type);
                            }
                        }}
                        label={field.label}
                    />
                }
            />
        </Form.Group>
    );
}

const editableListForm = (field, data, handleOption) => {
  let fieldData = _.get(field, "referenceDataSource", []);
  let sortData = _.sortBy(fieldData, (opt) =>
    _.toLower(_.get(opt, "name", _.get(opt, "label")))
  );
  return (
      <Form.Group
          className="m-0 p-0"
          key={"group-" + field.ref}
          as={Row}
          controlId={field.ref}>
          {formLabel(field)}
          <Form.Control
              as={Autocomplete}
              readOnly={field.readOnly}
              disableClearable
              key={"autocomplete-" + field.ref}
              className="formAutoComplete"
              classes={{
                  inputRoot: "formAutoCompleteRoot",
                  input: "formAutoCompleteInput",
                  listbox: "formList",
                  option: "formAutoCompleteOption",
                  popper: "formAutoCompletePopper",
              }}
              options={_.map(sortData, (option) =>
                  _.get(option, "name", _.get(option, "label"))
              )}
              autoHighlight
              renderInput={(params) => (
                <TextField
                {...params}
                InputProps={{ ...params.InputProps, disableUnderline: true }}
                required={field.required}
                placeholder={field.placeholder || field.label}
                />
              )}
              onKeyDown={(e) => {
                  if ((!_.get(field, "freeTyping", false) && (e.keyCode === 13 && !isListIncluded(field, "keyCode", _.get(data, field.ref, "")))) || e.keyCode === 46) {
                      e.preventDefault();
                      handleOption(field.ref, "", "autocomplete");
                  }
              }}
              inputValue={_.get(data, field.ref, "") ?? ""}
              onInputChange={(e, value) => {
                  if (!_.isEmpty(e)) {
                      e.preventDefault();
                      if (!_.get(field, "freeTyping", false)) {
                          value = isListIncluded(field, "value", _.get(data, field.ref, "")) && _.isEmpty(value) ? _.get(data, field.ref, "") : value;
                      }
                      handleOption(field.ref, value, "autocomplete");
                   }
              }}
              onBlur={(e) => {
                  if (!_.isEmpty(e)) {
                      e.preventDefault();
                      if (!_.get(field, "freeTyping", false) && !isListIncluded(field, "value", _.get(data, field.ref, ""))) {
                          handleOption(field.ref, "", "autocomplete");
                      }
                  }
              }}
              freeSolo={_.get(field, "freeTyping", false)}
          />
      </Form.Group>
  );
};
function compareString(type, stringName, value) {
  if (type === "keyCode") {
    return _.includes(_.toLower(stringName), _.toLower(value));
  } else {
    return stringName === value && type === "value";
  }
}
const isListIncluded = (field, type, value) => {
  let isListIncludedValue = false;
  let acctNameString;
  _.map(field.referenceDataSource, (option) => {
    acctNameString = _.get(option, "name", _.get(option, "label"));
    if (compareString(type, acctNameString, value)) {
      isListIncludedValue = true;
    }
  });
  return isListIncludedValue;
}

const nonEditableListForm = (field, data, handleOption, error = null, dueDate = null, handleMultiple = null, key = null) => {
    return (
        <>
            <Form.Group
                className="m-0 p-0"
                key={"group-" + field.ref}
                as={Row}
                controlId={field.ref}>
                {formLabel(field)}
                <Form.Control
                    as={Select}
                    className="formInputSelect"
                    classes={{
                        root: "dropdownRoot"
                    }}
                    disableUnderline={true}
                    displayEmpty
                    value={_.get(data, field.ref, "") || _.get(field, "default") || ""}
                    onChange={(e) => {
                        e.preventDefault();
                        if (key) {
                            handleOption(field.ref, e.target.value, key);
                        } else {
                            handleOption(field.ref, e.target.value, "non-edit-list");
                        }
                    }}
                    required={field.required}
                    inputProps={{
                        id: field.ref
                    }}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        },
                        getContentAnchorEl: null,
                        style: {
                            zIndex: 15000
                        }
                    }}
                >
                    <MenuItem className="dropdownSelect" value="">
                        -----
                    </MenuItem>
                    {_.map(field.referenceDataSource, (item, index) => {
                        const value = item.name || item.label || item;
                        return (
                            <MenuItem
                                className="dropdownSelect"
                                key={index}
                                value={value}
                            >
                                {value}
                            </MenuItem>
                        );
                    })}
                </Form.Control>
                <Form.Control.Feedback type="invalid">Please select a valid option.</Form.Control.Feedback>
                {_.has(data, "screenerType", false) ? (
                    <Reveal
                        key={_.get(field, "ref", "")}
                        showing={!_.isEmpty(_.get(data, _.get(field, "ref", "")))}
                        parentValue={_.get(data, _.get(field, "ref", ""))}
                        parentItem={field}
                        items={_.get(field, "reveal")}
                        data={data}
                        handleOption={handleOption}
                        error={error}
                        dueDate={dueDate}
                        handleMultiple={handleMultiple}
                    />
                ) : null}
            </Form.Group>
        </>
    )
}

const TIME_ZONE_NAME = "America/New_York";
const TIME_ZONE_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

const DateForm = ({field, data, dueDate = null, handleOption}) => {
    const dateRef = useRef(null);


    const getMinDate = () => {
        if (_.get(field, "disablePastDate")) {
            return new Date();
        }
        if (field.minDate === "Tomorrow"){
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            return tomorrow;
        } else if(field.refData === "dueDate") {
            return new Date(dueDate);
        } else {
            return new Date();
        }};

    if (_.isEmpty(_.get(data, _.get(field, "ref")))
        || _.isNil(_.get(data, _.get(field, "ref")))
        || moment(_.get(data, _.get(field, "ref"))).isBefore(moment(getMinDate()))) {
        let defaultValue = (field && field.default && field.default.date === "dueDate")
            ? moment(dueDate).tz(TIME_ZONE_NAME).format(TIME_ZONE_FORMAT)
            : moment(new Date()).tz(TIME_ZONE_NAME).format(TIME_ZONE_FORMAT);
        data[_.get(field, "ref")] = defaultValue;
    }

    const handleClickDatepickerIcon = () => {
        const datepickerElement = dateRef.current;
        datepickerElement.setFocus(true);
      }

    return (
        <Form.Group
            className="m-0 p-0"
            key={"group-" + field.ref}
            controlId={field.ref}>
            {formLabel(field)}
            <div className="datepickerCol">
                <DatePicker
                    id="datePicker"
                    className="formInput"
                    required={field.required}
                    name={field.label}
                    onChange={(value) => {
                        let date = Moment(_.isNil(value) ? getMinDate() : value).tz(TIME_ZONE_NAME).format(TIME_ZONE_FORMAT);
                        handleOption(field.ref, date);
                    }}
                    selected={new Date(_.get(data, _.get(field, "ref")))}
                    minDate={getMinDate()}
                    ref={dateRef}
                />
                <CalendarIcon
                    className="calendar_icon_modal"
                    onClick={handleClickDatepickerIcon}
                />
            </div>
    </Form.Group>
    )
}

const emailForm = (field, data, setData) => {
    return (
        <Form.Group
            className="m-0 p-0"
            key={"group-" + field.ref}
            as={Row}
            controlId={field.ref}
        >
            {formLabel(field)}
            <Form.Control
                className="formInput"
                autoComplete="off"
                placeholder={field.placeholder || field.label}
                required={field.required}
                value={
                    _.isEmpty(_.get(data, field.ref, []))
                        ? ""
                        : _.size(_.get(data, field.ref, [])) > 1
                        ? _.size(_.get(data, field.ref, [])) + " Contacts added"
                        : _.size(_.get(data, field.ref, [])) + " Contact added"
                }
                onClick={(e) => {
                    e.preventDefault();
                }}
                onChange={undefined}
            />
            <EmailPopper
                mode={"delivery"}
                data={_.get(data, field.ref, [])}
                source={data}
                setSource={setData}
                keyRef={field.ref}
            />
        </Form.Group>
    )
}

const multiLineForm = (field, data, handleOption) => {
    return (
        <Form.Group
            className="m-0 p-0"
            key={"group-" + field.ref}
            as={Row}
            controlId={field.ref}>
            {formLabel(field)}
            <Form.Control
                as="textarea"
                readOnly={field.readOnly}
                className="formInput"
                placeholder={field.placeholder || field.label}
                maxLength={_.get(field, "validations.length", 150)}
                value={_.get(data, field.ref, "")}
                onChange={(e) => {
                    e.preventDefault();
                    handleOption(field.ref, e.target.value)
                }}
                required={field.required}
            />
        </Form.Group>
    )
}

const textForm = (field, data, handleOption) => {
    return (
        <Form.Group
            className="p-0 m-0"
            key={"group-" + field.ref}
            as={Row}
            controlId={field.ref}
        >
            {formLabel(field)}
            <Form.Control
                className="formInput"
                autoComplete="off"
                placeholder={field.placeholder || field.label}
                required={field.required}
                maxLength={_.get(field, "validations.length", 150)}
                value={_.get(data, field.ref, "")}
                onChange={(e) => {
                    e.preventDefault();
                    handleOption(field.ref, e.target.value)
                }}
            />
        </Form.Group>
    )
}

const radioForm = (field, data, dueDate, error, handleOption) => {
    let items = _.get(field, "items");
    return (
        <Form.Group
            className="m-0 p-0"
            key={"group-" + field.ref}
            as={Row}
            controlId={field.ref}>
            {formLabel(field)}
            {_.has(error, field.ref, false) && !_.has(data, field.ref) ? (
                <p
                    className="help-block my-2 mx-0"
                    key={field.ref}
                >
                    {_.get(error, field.ref)}
                </p>
            ) : (
                ""
            )}
            {_.isEmpty(dueDate)
                ? _.map(items, (item) => (
                    <label key={field.ref + item}>
                        <input
                            type="radio"
                            name={field.ref}
                            id={field.ref + item}
                            required={field.required}
                            className="radioInput"
                            checked={_.get(data, _.get(field, "ref", "")) === item}
                            onChange={(e) => {
                                handleOption(field.ref, item);
                            }}
                            value={item}
                        />
                        <span className="mr-2 radioLabel">{item}</span>
                    </label>
                ))
                : _.map(items, (item) => (
                    <div key={field.ref + item} className="w-100">
                        <label>
                            <input
                                type="radio"
                                name={field.ref}
                                id={field.ref + item}
                                required={field.required}
                                className="radioInput"
                                checked={_.get(data, _.get(field, "ref", "")) === item}
                                onChange={(_e) => {
                                    handleOption(field.ref, item);
                                }}
                                value={item}/>
                            <span className="radioLabel">{item}</span>
                        </label>
                    </div>
                ))}
        </Form.Group>
    )
}

const numberForm = (field, data, handleOption) => {
    const min = _.get(field, "validations.min");
    const max = _.get(field, "validations.max");
    return (
        <Form.Group
            className="m-0 p-0"
            key={"group-" + field.ref}
            as={Row}
            controlId={field.ref}
        >
            {formLabel(field)}
            <Form.Control
                value={_.get(data, _.get(field, "ref", ""))}
                onChange={(e) => {
                    e.preventDefault();
                    handleOption(field.ref, e.target.value);
                }}
                required={field.required}
                min={min}
                max={max}
                defaultValue={_.get(data, _.get(field, "ref")) || min}
            />
        </Form.Group>
    )
}

const repeatedForm = (field, data, isEditing, handleOption, sourceKey = null) => {
    let repeat = parseInt(_.get(data, _.get(field, "numRepeated.ref")));

    if (repeat > -1) {
        let inputValues = [];
        _.times(
            repeat,
            function (idx) {
                let refValue = _.nth(_.get(data, field.ref, []), idx);
                let ref = field.ref[idx];
                inputValues.push(
                    <Form.Group key={"group-" + ref}
                                controlId={ref}
                                className ="m-0 p-0">
                        {formLabel(field)}
                        <Form.Control
                            className="formInput"
                            disabled={!isEditing}
                            placeholder={field.placeholder || field.label}
                            required={field.required}
                            value={refValue}
                            autoComplete="off"
                            onChange={(e) => {
                                e.preventDefault();
                                let getFieldVal = _.get(data, field.ref) || [];
                                let array = [...getFieldVal];
                                array[idx] = e.target.value;
                                if (sourceKey) {
                                    handleOption(field.ref, [..._.slice(array, 0, repeat)], sourceKey)
                                } else {
                                    handleOption(field.ref, [..._.slice(array, 0, repeat)]);
                                }
                            }}
                        />
                    </Form.Group>
                );
            }
        );
        return inputValues;
    } else {
        return (
            <Form.Group key={"group-" + field.ref}
                        controlId={field.ref}
                        className ="m-0 p-0">
                {formLabel(field)}
                <Form.Control
                    className="formInput"
                    disabled={!isEditing}
                    autoComplete="off"
                    placeholder={field.placeholder || field.label}
                    required={field.required}
                    onChange={(e) => {
                        e.preventDefault();
                        let key = field.ref;
                        let value = e.target.value;
                        if (sourceKey) {
                            if (field.ref === "forensicWatermarks") {
                                handleOption(key, [value], sourceKey);
                            } else {
                                handleOption(key, value, sourceKey);
                            }
                        } else {
                            if (field.ref === "forensicWatermarks") {
                                handleOption(key, [value]);
                            } else {
                                handleOption(key, value);
                            }
                        }
                    }}
                    defaultValue={
                        field.ref === "forensicWatermarks"
                            ? _.nth(_.get(data, _.get(field, "ref", ""), []), 0)
                            : _.get(data, _.get(field, "ref", ""))
                    }
                />
            </Form.Group>
        );
    }
}

const formLabel = (field) => {
    return (
        <>
            <Form.Label key={"label-" + field.ref} className="formLabel">
                {
                    <OverflowTool
                        text={
                            <FormLabelStyle
                                label={field.label}
                                impField={field.required}
                            />
                        }
                    />
                }
            </Form.Label>
            {_.has(field, "helpText", false) ? (
                <p className="help-block mx-0 mt-0 mb-2">
                    {field.helpText}
                </p>
            ) : (
                ""
            )}
        </>
    )
}

const helpTextForm = (field, dueDate) => {
    return (
        <div key={_.get(field, "value", _.get(field, "label"))}>
            {_.has(field, "label") && _.isEmpty(dueDate) ? (
                <label className="w-100">
                    {field.label}
                    <hr className="m-0 p-0"/>
                </label>
            ) : (
                <p className="help-block mx-0 mt-3 mb-0">
                    {field.value}
                </p>
            )}
        </div>
    );
}

const helpTextQC = (field) => {
    return (
        <div key={_.get(field, "label")}>
            <label className="qcHelpText">
                {field.label}
            </label>
        </div>
    );
}

const radioQC = (field, data, error, handleOption) => {
    let items = _.get(field, "items");
    return (
        <Form.Group
            className="m-0 p-0"
            key={"group-" + field.ref}
            as={Row}
            controlId={field.ref}>
            <Col xs={6}>
                <Form.Label key={"label-" + field.ref} className="qcLabel">
                    {
                        <OverflowTool
                            text={
                                <FormLabelStyle
                                    label={field.label}
                                    impField={field.required}
                                />
                            }
                        />
                    }
                </Form.Label>
                {_.has(field, "helpText", false) ? (
                    <p className="help-block mx-0 mt-0 mb-2">
                        {field.helpText}
                    </p>
                ) : (
                    ""
                )}
            {_.has(error, field.ref, false) && !_.has(data, field.ref) ? (
                <p
                    className="help-block my-2 mx-0"
                    key={field.ref}
                >
                    {_.get(error, field.ref)}
                </p>
            ) : (
                ""
            )}
            </Col>
            <Col xs={6}>
                {_.map(items, (item) => (
                    <label key={field.ref + item}>
                        <input
                            type="radio"
                            name={field.ref}
                            id={field.ref + item}
                            disabled={field.readOnly}
                            required={field.required}
                            className="radioInput"
                            checked={_.get(data, _.get(field, "ref", "")) === item}
                            onChange={(_e) => {
                                handleOption(field.ref, item);
                            }}
                            value={item}
                        />
                        <span className="mr-2 radioLabel">{item}</span>
                    </label>
                ))}
            </Col>
        </Form.Group>
    )
}

export const renderSourceLocationFields = (role, handleOption, value) => {
    const sourceLocations = ConfigUtils.getSourceLocations();
    return (
        <>
            {_.includes(PERMITTED_ROLES.MODAL_SOURCE_LOCATION_ROLES, role) ? (
                <Form.Group controlId="source_locations" className="m-0 p-0">
                    <Form.Label className="formLabel">Select Source Location</Form.Label>
                    <Form.Control
                        as={Select}
                        className="formInputSelect"
                        classes={{
                            root: "dropdownRoot"
                        }}
                        disableUnderline={true}
                        displayEmpty
                        value={value}
                        onChange={handleOption}
                        inputProps={{
                            id: "sourceLocations"
                        }}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                            getContentAnchorEl: null,
                            style: {
                                zIndex: 15000
                            }
                        }}>
                        <MenuItem className="dropdownSelect" value="">
                            -----
                        </MenuItem>
                        {_.map(sourceLocations, (item, index) => {
                            return (
                                <MenuItem className="dropdownSelect" key={index} value={item.value}>
                                    {item.label}
                                </MenuItem>
                            );
                        })}
                    </Form.Control>
                </Form.Group>
            ) : null}
        </>
    );
};
